const CustomSelect = () => {
    if ($('.custom-select').length <= 0) return null

    initCustomSelect();

    window.addEventListener('popstate', function(event) {
        console.log('pass');
        initCustomSelect();
      });
}

const initCustomSelect = () => {
    $('.custom-select').each(function() {
        const $form = $("form#FacetFiltersForm");
        const $parent = $(this);
        const $toggle = $parent.find('.cs-toggle');
        const $dropdown = $parent.find('.cs-dropdown');
        const $sel = $parent.find('select');

        //init get select value apply to ui
        const selInitVal = $sel.val();
        $dropdown.find(`.cs-dropdown--option[data-cs-option-value="${selInitVal}"]`).addClass('active');

        //bind toggle click
        $toggle.click(function() {
            $(this).closest('.custom-select').toggleClass('toggled');
        })

        //bind option clicks
        $dropdown.find('.cs-dropdown--option').click(function() {
            const $option = $(this);
            if ($option.hasClass('active')) return null;

            $dropdown.find('.cs-dropdown--option.active').removeClass('active');
            $(this).addClass('active');

            $parent.find('select').val($option.data('cs-option-value'));
            $form.trigger('submit');
        })

    })
}

export default CustomSelect